import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ApplicationState } from '@app/store';
import { getCrematoryFeaturesActionCreators } from '@app/store/CrematoryFeatures';
import { useCrematory } from '@app/hooks/Crematory/useCrematory';

export function useCrematoryFeatures() {
	const dispatch = useDispatch();
	const crematoryFeaturesStore = useSelector((state: ApplicationState) => state.crematoryFeatures);
	const crematory = useCrematory();

	React.useEffect(() => {
		if (!crematory) return;
		if (crematoryFeaturesStore.item) return;
		if (crematoryFeaturesStore.isLoading) return;

		const factory = getCrematoryFeaturesActionCreators();
		dispatch(factory.request(crematory.id));
	}, [crematory, crematoryFeaturesStore.item, dispatch]);

	return crematoryFeaturesStore;
}
